export function FilterPills({
  options,
  value,
  onChange,
}: {
  options: string[];
  value: string;
  onChange: (v: string) => void;
}): JSX.Element {
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {options.map((opt) => {
        const active = opt === value;
        return (
          <button
            key={opt}
            onClick={() => onChange(opt)}
            style={{
              border: `1px solid ${active ? 'var(--brand)' : 'var(--border)'}`,
              background: active ? 'var(--brand)' : 'var(--surface)',
              color: active ? '#fff' : 'var(--ink-mid)',
              fontSize: 12,
              fontWeight: 500,
              padding: '6px 12px',
              borderRadius: 999,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              flex: 'none',
            }}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
